export default __webpack_public_path__ + "static/media/ico_compra.30843a71.svg";